import { render } from "./ToxicologyResultsPreview.vue?vue&type=template&id=562a381b"
import script from "./ToxicologyResultsPreview.vue?vue&type=script&lang=js"
export * from "./ToxicologyResultsPreview.vue?vue&type=script&lang=js"

import "./ToxicologyResultsPreview.vue?vue&type=style&index=0&id=562a381b&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/ToxicologyResultsPreview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "562a381b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('562a381b', __exports__)) {
    console.log('reload')
    api.reload('562a381b', __exports__)
  }
  
  module.hot.accept("./ToxicologyResultsPreview.vue?vue&type=template&id=562a381b", () => {
    console.log('re-render')
    api.rerender('562a381b', render)
  })

}


export default __exports__